function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Message } from "../../elements/Message";
import { Link } from "../../elements/Link";
import { Divider } from "../../elements/Divider";
import { TextPlaceholder } from "../../elements/TextPlaceholder";
import { Pagination } from "../../elements/Pagination";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { size } from "../../../utils/size";
import { Dropdown } from "../../inputs/Dropdown";
import { FlexContainer } from "../../layout/FlexContainer";
import { PropertySearchResult } from "../PropertySearchResult";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { RESULTS } from "../../../utils/default-strings";
import { withResponsive } from "../../../utils/with-responsive";
import { PLACEHOLDERS, NUMBER_OF_PROPERTIES_PER_PAGE } from "./constants";
import { getNumberOfPages } from "./utils/getNumberOfPages";
import { getPropertySearchResultsToDisplay } from "./utils/getPropertySearchResultsToDisplay";
import { getFirstPropertyPositionOfActivePage } from "./utils/getFirstPropertyPositionOfActivePage";
import { getLastPropertyPositionOfActivePage } from "./utils/getLastPropertyPositionOfActivePage";
import { getShowingResultsText } from "./utils/getShowingResultsText";
import { getFlexDirection } from "./utils/getFlexDirection";
import { getResultsCountText } from "./utils/getResultsCountText";

var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activePage: 1
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (_ref, _ref2) {
      var previousControlledActivePage = _ref.activePage;
      var previousInternalActivePage = _ref2.activePage;
      var controlledActivePage = _this.props.activePage;
      if (controlledActivePage !== previousControlledActivePage) return _this.setState({
        activePage: controlledActivePage
      });
      var internalActivePage = _this.state.activePage;
      if (internalActivePage === previousInternalActivePage) return;

      _this.props.onChange(internalActivePage);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPageChange", function (event, _ref3) {
      var activePage = _ref3.activePage;
      return _this.setState({
        activePage: activePage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          _this$props$activePag = _this$props.activePage,
          activePage = _this$props$activePag === void 0 ? _this.state.activePage : _this$props$activePag,
          dropdownLabel = _this$props.dropdownLabel,
          dropdownOnChange = _this$props.dropdownOnChange,
          dropdownOptions = _this$props.dropdownOptions,
          dropdownValue = _this$props.dropdownValue,
          isShowingPlaceholder = _this$props.isShowingPlaceholder,
          isUserOnMobile = _this$props.isUserOnMobile,
          messageButtonOnClick = _this$props.messageButtonOnClick,
          messageButtonText = _this$props.messageButtonText,
          messageText = _this$props.messageText,
          propertySearchResults = _this$props.propertySearchResults,
          resultsCountText = _this$props.resultsCountText,
          renderResultsCountText = _this$props.renderResultsCountText,
          renderShowingResultsText = _this$props.renderShowingResultsText,
          sortResultsWrapperClassName = _this$props.sortResultsWrapperClassName;
      var propertySearchResultsToDisplay = getPropertySearchResultsToDisplay(activePage, propertySearchResults);
      var length = propertySearchResults.length;
      return React.createElement("div", {
        className: "property-search-result-list"
      }, React.createElement("div", {
        className: "result-list-container"
      }, React.createElement(FlexContainer, {
        alignItems: "center",
        className: sortResultsWrapperClassName,
        justifyContent: "space-between"
      }, isShowingPlaceholder ? React.createElement(FlexContainer, null, React.createElement(TextPlaceholder, {
        length: "short"
      })) : React.createElement(Heading, {
        size: "small"
      }, renderResultsCountText(length, resultsCountText)), !!size(dropdownOptions) && React.createElement(Dropdown, {
        isCompact: true,
        label: dropdownLabel,
        onChange: dropdownOnChange,
        options: dropdownOptions,
        value: dropdownValue
      })), messageText ? React.createElement(Message, {
        isTextAlignedCenter: isUserOnMobile
      }, React.createElement(FlexContainer, {
        alignItems: "center",
        flexDirection: getFlexDirection(isUserOnMobile),
        justifyContent: "space-between"
      }, messageText, React.createElement(Link, {
        isFluid: isUserOnMobile,
        onClick: messageButtonOnClick
      }, messageButtonText))) : React.createElement(Divider, {
        size: "small"
      }), React.createElement(FlexContainer, {
        flexWrap: "wrap"
      }, (isShowingPlaceholder ? PLACEHOLDERS : propertySearchResultsToDisplay).map(function (propertySearchResult, index) {
        return React.createElement(PropertySearchResult, _extends({
          isShowingPlaceholder: isShowingPlaceholder,
          key: buildKeyFromStrings(propertySearchResult.propertyName, index)
        }, propertySearchResult));
      })), length > NUMBER_OF_PROPERTIES_PER_PAGE && React.createElement(FlexContainer, {
        alignItems: "center",
        flexDirection: "column",
        flexWrap: "wrap"
      }, React.createElement(Pagination, {
        activePage: activePage,
        isShowingPageNumbers: true,
        onPageChange: _this.handleOnPageChange,
        totalPages: getNumberOfPages(length)
      }), React.createElement(Paragraph, null, renderShowingResultsText(getFirstPropertyPositionOfActivePage(activePage), getLastPropertyPositionOfActivePage(activePage, length), length)))));
    });

    return _this;
  }

  return Component;
}(PureComponent);

Component.displayName = 'PropertySearchResultList';
Component.defaultProps = {
  activePage: undefined,
  dropdownLabel: null,
  dropdownOnChange: Function.prototype,
  dropdownOptions: null,
  dropdownValue: undefined,
  isShowingPlaceholder: false,
  messageButtonOnClick: Function.prototype,
  messageButtonText: null,
  messageText: null,
  onChange: Function.prototype,
  propertySearchResults: [],
  renderResultsCountText: getResultsCountText,
  renderShowingResultsText: getShowingResultsText,
  resultsCountText: RESULTS,
  sortResultsWrapperClassName: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activePage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dropdownLabel: PropTypes.string,
  dropdownOnChange: PropTypes.func,
  dropdownOptions: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.node,
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  dropdownValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  isShowingPlaceholder: PropTypes.bool,
  isUserOnMobile: PropTypes.bool.isRequired,
  messageButtonOnClick: PropTypes.func,
  messageButtonText: PropTypes.string,
  messageText: PropTypes.string,
  onChange: PropTypes.func,
  propertySearchResults: PropTypes.arrayOf(PropTypes.object),
  renderResultsCountText: PropTypes.func,
  renderShowingResultsText: PropTypes.func,
  resultsCountText: PropTypes.string,
  sortResultsWrapperClassName: PropTypes.string
} : {};
export var ComponentWithResponsive = withResponsive(Component);